export default __webpack_public_path__ + "static/media/icon_instagram.d8b15255.svg";